// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI);
import 'babel-polyfill'
import GlobalCss from './assets/global-ui.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import _promise from 'es6-promise'
import axios from 'axios'
import qs from 'qs'
import Mint from 'mint-ui'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import 'iview/dist/iview.min.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import VideoPlayer from 'vue-video-player'
import utils from './utils'; //获取url参数
import store from './store/index'
import Vuex from 'vuex' //引入vuex
//import setTitle from './assets/script/settitle.js'
import setTitle from './assets/script/settiltle'


import   "babel-polyfill"
import Viewer from 'v-viewer'

import 'viewerjs/dist/viewer.css'



window.setTitle = setTitle;
Vue.prototype.$utils = utils; //注册全局方法

_promise.polyfill();

Vue.config.productionTip = false;
Vue.prototype.$ajax = axios;
Vue.config.devtools = true;
Vue.use(VideoPlayer);
Vue.use(VueAwesomeSwiper);
// Vue.use(axios);
Vue.use(Vuex);
Vue.use(store);


//配置默认host

// axios.defaults.baseURL = 'httpL://localhost:8081';
// axios.defaults.baseURL = 'http://192.168.1.113:8012';
axios.defaults.baseURL = '/api';
// axios.defaults.baseURL = 'http://bwapi.boyuancb.com:8012';
// axios.defaults.baseURL = 'http://192.168.1.109';

axios.interceptors.request.use(
	config => {
		config.headers.Authorization = 'Bearer test';
		//  var token=document.querySelector('input[type=hidden]').value;
		//   if (token) {
		//       config.headers.Authorization = 'Bearer ' + token;
		//   }
		return config;
	},
	err => {
	console.log(err);
		return Promise.reject(err);
	});


router.beforeEach((to, from, next) => {
    // window.scrollTo(0, 0);
    next();
})

// 路由变化
router.afterEach(function(to) {
    if (to.meta && to.meta.title) {
        setTitle(to.meta.title);
    }
})

/* eslint-disable no-new */
var vm = new Vue({
    store,
    el: '#app',
    router,
    data() {
        return {
            isWeiXin: false,
            toPath: ''
        }
    },
    template: '<App/>',
    components: { App },
    updated() {

    },
    created() {
        let isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 }
        if (isWeiXin()) {
            isWeiXin = true;
        } else {
            isWeiXin = false;
        }
        console.log('isWeiXin:' + isWeiXin);
    },
})



// WEBPACK FOOTER //
// ./src/main.js